export enum HandballFoulAttribute {
  OffensiveFoul = 472,
  DefenceInGoalArea = 473,
  CausesPenalty = 1061,
}
